import { status } from 'nprogress';
var labels = {
  management_title: {
    es: 'Informe de gestión de accesos',
    en: 'Access management report'
  },
  subtitle_management: {
    es: 'Informe general de los accesos brindados a los usuarios de INCA Platform sobre las tablas de la organización.',
    en: "Overall report of the accesses granted to INCA Platform users on the organization's tables."
  },
  no_metadata: {
    es: 'Informe de tablas sin metadata',
    en: 'Tables without metadata report'
  },
  subtitle_no_metadata: {
    es: 'Informe de las tablas que se encuentra creadas en los proyectos de BigQuery que INCA Platform tiene acceso. Se puede realizar la sincronización para que la tabla se visualice en Mis Tareas - Asignación de Tablas.',
    en: 'Report of the tables created in BigQuery projects that INCA Platform has access to. It is possible to synchronize the table so that it is displayed in My Tasks - Table Assignment.'
  },
  dashboard_title: {
    es: 'Tablero de perfilamiento',
    en: 'Profiling dashboard'
  },
  subtitle_dashboard: {
    es: '',
    en: ''
  },
  pipeline_title: {
    es: 'Pipeline de linaje de datos',
    en: 'Linaje data pipeline'
  },
  subtitle_pipeline: {
    es: 'Diagrama interactivo que permite visualizar el linaje de datos de los pipelines de la organización.',
    en: "Interactive diagram that allows you to visualize the data lineage of the organization's pipelines."
  },
  modules_title: {
    es: 'Accesos por módulo',
    en: 'Module access'
  },
  subtitle_modules: {
    es: '',
    en: ''
  },
  tablas_monitoring: {
    nivel: 2,
    benefited: {
      es: 'Beneficiado',
      en: 'Benefited'
    },
    applicant: {
      es: 'Solicitante',
      en: 'Applicant'
    },
    application: {
      es: 'Aplicación',
      en: 'Application'
    },
    table_id: {
      es: 'Table Id',
      en: 'Tabla Id'
    },
    view_id: {
      es: 'View Id',
      en: 'Vista Id'
    },
    status: {
      es: 'Estado',
      en: 'Status'
    },
    first_interaction: {
      es: 'Primer Acceso Otorgado',
      en: 'First Access Granted'
    },
    last_interaction: {
      es: 'Último Acceso Otorgado',
      en: 'Last Access Granted'
    },
    table_project: {
      es: 'Proyecto de tabla',
      en: 'Table project'
    },
    table_dataset: {
      es: 'Dataset de tabla',
      en: 'Table dataset'
    },
    table: {
      es: 'Tabla',
      en: 'Table'
    },
    view_project: {
      es: 'Proyecto de la vista',
      en: 'View project'
    },
    view_dataset: {
      es: 'Dataset de la vista',
      en: 'View Dataset'
    },
    view: {
      es: 'Vista',
      en: 'View'
    },
    creation_date: {
      es: 'Fecha de creación',
      en: 'Creation date'
    },
    expiration_date: {
      es: 'Fecha de expiración',
      en: 'Expiration date'
    },
    project: {
      es: 'Proyecto',
      en: 'Project'
    },
    dataset: {
      es: 'Dataset',
      en: 'Dataset'
    },
    columns: {
      es: 'Columnas',
      en: 'Columns'
    },
    rows: {
      es: 'Filas',
      en: 'Rows'
    },
    module: {
      es: 'Módulo',
      en: 'Module'
    },
    historic: {
      es: 'Histórico',
      en: 'Historic'
    },
    last_3: {
      es: 'Últimos 3 meses',
      en: 'Last 3 months'
    },
    current_month: {
      es: 'Mes actual',
      en: 'Current month'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    },
    approval_user: {
      es: 'Usuario de aprobación',
      en: 'Approval user'
    }
  },
  search_filters: {
    es: 'Filtros de Búsqueda',
    en: 'Search Filters'
  },
  search_project: {
    es: 'Buscar por proyecto',
    en: 'Search by project'
  },
  search_dataset: {
    es: 'Buscar por dataset',
    en: 'Search by dataset'
  },
  search_table: {
    es: 'Buscar por tabla',
    en: 'Search by table'
  },
  api_filters: {
    es: 'Filtros del API',
    en: 'API Filters'
  },
  search_company: {
    es: 'Nombre de la compañía',
    en: 'Company name'
  },
  search_group: {
    es: 'Nombre del grupo',
    en: 'Group name'
  },
  search_zone: {
    es: 'Nombre de la zona',
    en: 'Zone name'
  },
  execution_date: {
    es: 'Fecha de ejecución',
    en: 'Execution date'
  },
  job_code: {
    es: 'Código de trabajo',
    en: 'Job code'
  },
  local_filters: {
    es: 'Filtros locales',
    en: 'Local filters'
  },
  job_type: {
    es: 'Tipo de trabajo',
    en: 'Job type'
  },
  job_status: {
    es: 'Estado de trabajo',
    en: 'Job status'
  },
  legend: {
    es: 'Leyenda',
    en: 'Legend'
  },
  orchestation: {
    es: 'Orquestación',
    en: 'Orchestation'
  },
  transformation: {
    es: 'Transformación',
    en: 'Transformation'
  },
  hide_details: {
    es: 'Ocultar detalles',
    en: 'Hide details'
  },
  show_details: {
    es: 'Ver detalles',
    en: 'Show details'
  },
  renew_access: {
    es: 'Renovar acceso',
    en: 'Renew access'
  },
  remove_access: {
    es: 'Quitar acceso',
    en: 'Remove access'
  },
  email_benefited: {
    es: 'Correo del beneficiado',
    en: 'Email of benefited'
  },
  email_benefited_ph: {
    es: 'Ingrese correo del beneficiado',
    en: 'Enter full e-mail of benefited'
  },
  email_applicant: {
    es: 'Correo del solicitante',
    en: 'Email of applicant'
  },
  email_applicant_ph: {
    es: 'Ingrese correo del solicitante',
    en: 'Enter full e-mail of benefited'
  },
  status: {
    es: 'Estado',
    en: 'Status'
  },
  table_project: {
    es: 'Proyecto de tabla',
    en: 'Table project'
  },
  table_dataset: {
    es: 'Dataset de tabla',
    en: 'Table dataset'
  },
  date_interval: {
    es: 'Intervalo de fechas',
    en: 'Date interval'
  },
  sync: {
    es: 'Sincronizar',
    en: 'Sync'
  },
  access_details: {
    es: 'Detalles de Acceso',
    en: 'Access Details'
  },
  permissions_details: {
    es: 'Detalle de Permisos',
    en: 'Permissions Details'
  },
  name: {
    es: 'Nombre',
    en: 'Name'
  },
  type: {
    es: 'Tipo',
    en: 'Type'
  },
  description: {
    es: 'Descripción',
    en: 'Description'
  },
  sensitive: {
    es: 'Sensible',
    en: 'Sensitive'
  }
};
export default labels;